import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal, inject } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IEcoupon } from '@web-nx-ng-tsc/campaign-shared-data-access';
import { FormEcouponService } from '@web-nx-ng-tsc/shared-feat';
import { CommonModule } from '@angular/common';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
// import { DialogAnnoucementComponent } from '../../../../../../../apps/campaign/ecoupon-toyo/src/app/dialog-annoucement/dialog-annoucement.component';
import { LibDialogAnnounceComponent } from '../lib-dialog-announce/lib-dialog-announce.component';

@Component({
  selector: 'ecoupon-shared-ui-lib-ecoupon-form',
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    CommonModule,
    MatDialogModule,
  ],
  templateUrl: './lib-ecoupon-form.component.html',
  styleUrl: './lib-ecoupon-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class libEcouponFormComponent {
  // @ViewChild('myForm') myForm!: NgForm;
  @Input() set errMsg(value: string) {
    this.errorMessage = value;
  }
  @Input() set id(value: string) {
    this.idPath = value;
  }
  @Input() set data(value: any) {
    this.detail = value;
    this.loggingService.log('this.detail', this.detail);
  }
  @Input() set pathFrom(value: any) {
    if (value == 'toyo') {
      this.codeCampaign = 'TY0325';
    } else if (value == 'nitto') {
      this.codeCampaign = 'NT0325';
    }
  }

  @Output() emitEcouponForm = new EventEmitter();
  route = inject(ActivatedRoute);
  idPath = '';
  detail: any;
  codeCampaign = 'AA0325';

  readonly dialog = inject(MatDialog);

  private readonly formEcouponService = inject(FormEcouponService);
  private readonly loggingService = inject(LoggingService);

  eCouponForm = signal<IEcoupon>({
    campaign_id: '',
    brand: 'toyo',
    firstname: '',
    lastname: '',
    mobile: '',
    car_license: '',
    car_province: '',
    code: '',
  });
  errorMessage = '';
  provinceListSignal = this.formEcouponService.getProvinceListSignal();
  passFormSignal = this.formEcouponService.getpassFormSignal();

  // errMsg = this.formEcouponService.getErrorMessageSignal();
  constructor() {
    this.formEcouponService.clearDataFormSignal();
  }

  onClick(form: NgForm, event: Event) {
    this.eCouponForm().campaign_id = this.idPath;
    // this.formEcouponService.setDataFormSignal(this.eCouponForm());
    // this.formEcouponService.postForm(this.eCouponForm());
    // this.loggingService.log('this.passFormSignal()', this.passFormSignal());
    // if (this.passFormSignal()) {
    //   this.loggingService.log('onClick | check passFormSignal()');
    //   this.emitEcouponForm.emit(this.eCouponForm());
    // }
    event.preventDefault();
    if (form.valid) {
      this.loggingService.log('Form submitted:', this.eCouponForm());
      // ตัวอย่าง: แสดงข้อความแจ้งเตือน
      this.emitEcouponForm.emit(this.eCouponForm());
    }
  }

  openDialogAnnounce() {
    const dialogRef = this.dialog.open(LibDialogAnnounceComponent, {
      autoFocus: 'dialog',
      restoreFocus: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  validateInput(event: KeyboardEvent) {
    const regex = /^[a-zA-Zก-๙ ]+$/;
    const inputChar = event.key;

    if (!regex.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateInputCarNumer(event: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9ก-๙]+$/;
    const inputChar = event.key;

    if (!regex.test(inputChar)) {
      event.preventDefault();
    }
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const pattern = /^[0-9]$/;
    if (!pattern.test(event.key)) {
      event.preventDefault();
    }
  }
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const userId = params.get('id');

      if (!userId || !/^\d+$/.test(userId)) {
        this.loggingService.error('Invalid User ID');
      }
    });
    this.formEcouponService.getProvince().subscribe();
  }
}
